import script from "./OapShadeFinderCarousel.vue?vue&type=script&lang=js"
export * from "./OapShadeFinderCarousel.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__